import AML from '@company-common/model/kyc-form/AML'
import Validation from '@core/logic/Validation'

export default class AMLValidation extends Validation {
  validate (aml: AML, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, REQUIRE_TRUE, WHEN } = this.validator()

    ADD(REQUIRE(aml.adverseDBChecks, 'Adverse results from private database check must be yes or no.'), ['Client\'s AML Check'], ['adverseDBChecks'])
    ADD(REQUIRE(aml.redFlag, ' Red Flags must be yes or no'), ['Client\'s AML Check'], ['redFlag'])
    ADD(REQUIRE(aml.sanctioned, 'Positive identification against Singapore and international sanctions /wanted / blacklists must be yes or no'), ['Client\'s AML Check'], ['sanctioned'])
    ADD(REQUIRE(aml.financialFlowHighRisk, 'Financial flows involving tax-havens and/or High-Risk Countries must be yes or no'), ['Client\'s AML Check'], ['financialFlowHighRisk'])
    ADD(REQUIRE(aml.pepAssociated, 'PEP or associated/related to PEP must be yes or no'), ['Client\'s AML Check'], ['pepAssociated'])
    ADD(REQUIRE(aml.transactValueBelowThreshold, 'Transaction Value Below S$20,000 must be yes or no'), ['Client\'s AML Check'], ['transactValueBelowThreshold'])
    ADD(REQUIRE(aml.applyMedicalProduct, 'Applying for Medical Plan products must be yes or no'), ['Client\'s AML Check'], ['applyMedicalProduct'])

    return getMessages()
  }
}
